// Module
var code = `<div>
    <div class="row margin-bottom" data-bind="validationElement: configurationScript.exec">
        <label class="control-label col-xs-12 col-sm-6 col-lg-4">
            Exec
        </label>
        <div class="col-xs-12 col-sm-6 col-lg-8">
            <input data-bind="textInput: configurationScript.exec" type="text" class="form-control" placeholder="Path to executable">
        </div>
    </div>
    <div class="row margin-bottom" data-bind="validationElement: configurationScript.arguments">
        <label class="control-label col-xs-12 col-sm-6 col-lg-4">
            Arguments
        </label>
        <div class="col-xs-12 col-sm-6 col-lg-8">
            <input data-bind="textInput: configurationScript.arguments" type="text" class="form-control" placeholder="Command line arguments passed to exec">
        </div>
    </div>
    <div class="row margin-bottom" data-bind="validationElement: configurationScript.timeoutInMs">
        <label class="control-label col-xs-12 col-sm-6 col-lg-4">
            Timeout
        </label>
        <div class="col-xs-12 col-sm-6 col-lg-8">
            <div class="input-group">
                <input data-bind="numericInput: configurationScript.timeoutInMs" min="0" type="number" class="form-control">
                <div class="input-group-addon">
                    ms
                </div>
            </div>
        </div>
    </div>
</div>
`;
// Exports
export default code;